import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  ANALYTICS_CONSENT_EVENT,
  getAnalyticsConsent,
  setAnalyticsConsent,
  trackPageView,
} from "@/lib/analytics";

export default function AnalyticsConsent() {
  const location = useLocation();
  const [consent, setConsent] = useState(getAnalyticsConsent);

  useEffect(() => {
    const update = (event) => setConsent(event.detail);
    window.addEventListener(ANALYTICS_CONSENT_EVENT, update);
    return () => window.removeEventListener(ANALYTICS_CONSENT_EVENT, update);
  }, []);

  useEffect(() => {
    trackPageView(`${location.pathname}${location.search}${location.hash}`);
  }, [consent, location.hash, location.pathname, location.search]);

  if (consent) return null;

  return (
    <aside
      className="fixed inset-x-0 bottom-0 z-[100] border-t border-border bg-background/95 shadow-2xl backdrop-blur"
      aria-label="Analytics cookie preferences"
      data-testid="analytics-consent"
    >
      <div className="page-shell flex flex-col gap-4 py-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex max-w-3xl gap-3">
          <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-primary" />
          <p className="text-sm leading-6 text-muted-foreground">
            We use anonymous first-party statistics to improve the site, with no stored IP, full browser signature or visitor ID.
            Google Analytics stays off unless you accept. You can reject all measurement. Read our <Link to="/privacy" className="font-bold text-foreground underline underline-offset-4">privacy notice</Link>.
          </p>
        </div>
        <div className="flex shrink-0 gap-2">
          <Button variant="outline" onClick={() => setAnalyticsConsent("rejected")}>Reject all</Button>
          <Button variant="outline" onClick={() => setAnalyticsConsent("anonymous")}>Anonymous only</Button>
          <Button onClick={() => setAnalyticsConsent("accepted")}>Accept analytics</Button>
        </div>
      </div>
    </aside>
  );
}
